<template>
  <div id="survey">
    <survey-header />

    <div class="survey-wrap">
      <div class="grid-container survey-container">
        <div class="survey-grid">
          <h2 v-if="content.title">{{ content.title }}</h2>

          <h3 class="q" v-if="content.q">{{ content.q }}</h3>

          <component :is="'survey-'+compIs" :content="content.form" :slug="slug" />

          <Status :id="id" />
        </div>
      </div>
    </div>

    <survey-spacer />

    <survey-footer />
  </div>
</template>

<script>
import Status from '@/views/Status'
import Binary from '@/views/Types/Binary'
// import Binary2 from '@/views/Types/Binary2'
import Radio from '@/views/Types/Radio'
import Slider from '@/views/Types/Slider'
import Slider2 from '@/views/Types/Slider2'
import Checkbox from '@/views/Types/Checkbox'
// import Checkbox2 from '@/views/Types/Checkbox2'
import Button from '@/views/Types/Button'
import Report from '@/views/Report'
import Footer from '@/views/Survey/Footer'
import Spacer from '@/views/Survey/Spacer'
import Header from '@/views/Survey/Header'

export default {
  name: 'Survey',
  components: {
    Status,
    'survey-binary': Binary,
    // 'survey-binary2': Binary2,
    'survey-radio': Radio,
    'survey-slider': Slider,
    'survey-slider2': Slider2,
    'survey-checkbox': Checkbox,
    // 'survey-checkbox2': Checkbox2,
    'survey-button': Button,
    'survey-report': Report,
    'survey-footer': Footer,
    'survey-spacer': Spacer,
    'survey-header': Header
  },
  data() {
    return {
      id: this.$route.params.q,
      from: this.$route.params.from,
      content: false,
      //chosen: false
    }
  },
  methods: {
    getContent() {
      this.content = {
        title: this.$store.state.content[this.slug].title,
        q: this.$store.state.content[this.slug].q,
        form: this.$store.state.content[this.slug].form
      };
    },
  },
  computed: {
    slug() {
      // if(this.from === 'home') {
      //   return 'intro';
      // }

      return this.$store.state.flow.flow[this.id].slug;
    },
    compIs() {
      return this.content.form.type;
    },
  },
  created() {
    this.getContent();
  },
  beforeRouteEnter(to, from, next){
    next(vm => {
      // let resp = vm.$store.state.formData;
      // let len = Object.keys(resp).length;
      let q = vm.$attrs.q;
      // if(!len && q == 0){
      if( q === 0 ){
        next();
      } else {
        next('/');
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.id = parseInt(to.params.q, 10);
    this.from = to.params.from;
    this.getContent();
    //console.log(from);
    next();
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/vars";
@import "../assets/scss/mixins";

#survey {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  color: white;
}

.survey-container {
  padding-bottom: gu(2);
}

.survey-grid {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  // min-height: 50vh;
  // padding: 4rem 0;
  z-index: 3;

  h2 {
    font-size: rem-calc(45);
    font-weight: $fwBold;
    text-transform: uppercase;
    margin-bottom: gu(3);
    line-height: 1;
    //font-weight: $fwBold;

    @media only screen and (min-width: 40rem) {
      font-size: rem-calc(55);
      margin-bottom: gu(6);
    }
    
    @media only screen and (min-width: 64rem) {
      font-size: rem-calc(65);
    }
  }

  h3 {
    font-weight: $fwBold;
    max-width: 80%;
    // margin-bottom: gu(1);

    @media only screen and (min-width: 40rem) {
      max-width: 80%;
    }
  }
}
</style>
